import { render, staticRenderFns } from "./DeviceFilterReviews.vue?vue&type=template&id=18cb26ba&"
import script from "./DeviceFilterReviews.vue?vue&type=script&lang=js&"
export * from "./DeviceFilterReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18cb26ba')) {
      api.createRecord('18cb26ba', component.options)
    } else {
      api.reload('18cb26ba', component.options)
    }
    module.hot.accept("./DeviceFilterReviews.vue?vue&type=template&id=18cb26ba&", function () {
      api.rerender('18cb26ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/devicereviews/DeviceFilterReviews.vue"
export default component.exports